import ApplicationController from "@mixitone/mvc";
import type { useModals, useNavigate } from "router";
import RouteController from "./RouteController";

type NavigateType = ReturnType<typeof useNavigate>;
type ModalsType = ReturnType<typeof useModals>;

export default class MixitoneController<State extends object, Props = object> extends ApplicationController<
  State,
  Props
> {
  /**
   * @example
   * routeService.openModal("modalName", { state: { foo: "bar" } });
   */
  public actionOpenModal: ModalsType["open"] = (...args) => {
    this.get(RouteController).actionOpenModal(...args);
  };

  public actionCloseModal: ModalsType["close"] = (...args) => {
    this.get(RouteController).actionCloseModal(...args);
  };

  public isModalOpen(): boolean {
    return this.get(RouteController).isModalOpen();
  }

  public actionForward: NavigateType = (...args) => {
    this.get(RouteController).actionForward(...args);
  };

  async actionBack() {
    this.debug("Going back");
    return this.get(RouteController).actionBack();
  }
}
